import { getDocs, collection, getFirestore } from "firebase/firestore";

export const queryEmployeeDocuments = async (idNumber: string | undefined) => {
  if (!idNumber) 
    return [];

  const db = getFirestore();
  // Get Personal documents
  return await getDocs(collection(db, `Employees/${idNumber}/PersonalDocuments`)).then((qSnapshot) => {
    return qSnapshot.docs.map((qDSnap) => {
      const data = qDSnap.data();
      return {
        title: qDSnap.id,
        file: data.file,
        expire: data.expire,
      };
    });
  });
};